import { type z } from 'zod';

import { makeListQuery } from '../../common/list-query/list-query';

/**
 * The query for `GET /guardian/wards/:linkId/conversations` — pagination, and
 * deliberately nothing else.
 *
 * **No filters.** Chat's own list offers `status` and `matchId` because a member
 * navigates her own threads; a wali is reading a short, complete list of the
 * conversations one ward is having, and a filter here would only let him narrow
 * *which* of them he is watching — which is not a capability the relationship
 * needs and is one more thing to explain in two locales.
 *
 * `sort` and `order` ride along from `makeListQuery` and are **discarded by the
 * service**, exactly as `ConversationsListQuerySchema`'s are: a thread list has
 * one meaningful order (most recently active first, silent threads last), and
 * offering others would buy a second index for no product.
 */
export const GuardianWardConversationsQuerySchema = makeListQuery({});

export type GuardianWardConversationsQuery = z.infer<typeof GuardianWardConversationsQuerySchema>;
